import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import checkedCircle from "@/assets/check-circle.png";
import AuthPageShell from "../components/AuthPageShell";
import AuthPrimaryButton from "../components/AuthPrimaryButton";

const SuccessfulForgotPasswordPage = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <AuthPageShell title={t("success.forgotPassword.title")}>
      <div className="flex flex-col items-center gap-4 text-center">
        <img src={checkedCircle} alt="success" className="h-12 w-12" />

        <AuthPrimaryButton type="button" onClick={handleLoginClick}>
          {t("success.forgotPassword.goToLogin")}
        </AuthPrimaryButton>
      </div>
    </AuthPageShell>
  );
};

export default SuccessfulForgotPasswordPage;
